import React, { useState } from 'react';

import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import CircleIcon from '@mui/icons-material/Circle';

// **** CUSTOM IMPORTS


import DownloadFramework from "../nav/DownloadFramework";


const styles = {
  paperContainer: {
      backgroundImage: `url(${"pipe-bw.png"})` ,
      backgroundRepeat: `no-repeat`,
      backgroundPositionX:"30%",
      backgroundPositionY:"-2050px",
  }
};

const TermsTop = (props) => {



  console.log ("MainTop RENDERED______")

  const launchDfinity = () => {
    window.open ("https://dfinity.org/", "_blank" );
  };



  return (
    <Paper elevation={0} sx={{border:"0px solid #fff6ee", backgroundColor: "#fff",border:"1px solid #fff6ee", borderRadius:2, justifyContent:"right",
          backgroundImage: {
            xs: ``,
            sm: `url(${"pipe-bw.png"})`,
          } ,
          backgroundRepeat: `no-repeat`,
          backgroundPositionX:"30%",
          backgroundPositionY:"-2050px",
          }} >
      <Grid container>
      <Grid item xs={12} sx={{ display:"flex"}}> 
      

      <Paper elevation={0} sx={{ backgroundColor: "#ffffff", border:"1px solid #9f9f9f", borderRadius:2,m:2, p:2, flexGrow:1 }} >
            <Grid container cellSpacing={2}>
              <Grid item xs={12}>
              <Typography
                component="h5"
                variant="h5"
                align="center"
                color="#000000"
              >
                Privacy Policy, Terms & Conditions
              </Typography>

              </Grid>
            </Grid>
          </Paper>
        
        </Grid>
        <Grid item xs={12} >
          
      <Paper elevation={0} sx={{ backgroundColor: "#ffffff", border:"1px solid #9f9f9f", borderRadius:2,m:2, p:2, flexGrow:1 }} >
            <Grid container cellSpacing={2}>
              <Grid item xs={12}>
              

                <Typography component="p" variant="body2" align="left" color="#000000" sx={{pb:1}}>
                  Welcome to ICArchive, where we value you, your privacy and the security of your information.  
                  Our intentions with respect to information we may collect are centered on providing the best products and services we possibly can.  
                  Accordingly, we may use your data to:
                  </Typography>

                  <Typography component="p" variant="body2" align="left" color="#000000" sx={{pb:1}}>

                  <CircleIcon sx={{pr:2, pt:1}} fontSize="small"  />
                  provide services and manage access to said services;
                  </Typography>
                  <Typography component="p" variant="body2" align="left" color="#000000" sx={{pb:1}}>

                  <CircleIcon sx={{pr:2, pt:1}} fontSize="small"  />

                  communicate with users about our services and/or provide support with respect to use of the services;
                  </Typography>
                  <Typography component="p" variant="body2" align="left" color="#000000" sx={{pb:1}}>

                  <CircleIcon sx={{pr:2, pt:1}} fontSize="small"  />

                  for research and development aimed at improving our services.
                  </Typography>
                    
                    
                    <Typography component="p" variant="body2" align="left" color="#000000" sx={{pb:1}}>
                    If our website uses cookies, it's only to make the site work better for you.  Ditto with any information we gather about your device.

                    </Typography>
                    <Typography component="p" variant="body2" align="left" color="#000000" sx={{pb:1}}>
                      If we ask for your email, it's just so we know how to contact you.  We don't sell your information, and we don't share it, even with our operating partners, without first seeking your permission to do so.
                      </Typography>
                    <Typography component="p" variant="body2" align="left" color="#000000" sx={{pb:1}}>
                      If you log into ICArchive using your Internet Identity, it is entirely pass-through.  We do not handle or have any visibility to your information in-flight.  
                      While we may associate your Internet Identity with your ICArchive profile, it's just so we know it's you.  
                      Internet Identity is itself a best-practices implementation of the WebAuthn standard, so your privacy is the whole idea.
                    </Typography>
                    <Typography component="p" variant="body2" align="left" color="#000000" sx={{pb:1}}>
                      If we send you emails, they may include technologies that let us know you've received and/or opened our email, or if you have clicked links that may appear in the email. 
                      In the event of a merger or acquisition, we may share your information with parties to that transaction.  In any such event, your privacy will remain a first priority, and notice will be published in advance.
                    </Typography>
                    <Typography component="p" variant="body2" align="left" color="#000000" sx={{pb:1}}>
                      Please note that we may disclose your information to law enforcement, as may be necessitated by subpoena, court order, warrant or other valid government order.
                    </Typography>
                    <Typography component="p" variant="body2" align="left" color="#000000" sx={{pb:1}}>

                      Your data residing with us, while encrypted, may traverse geographical boundaries including international borders, being stored on the Internet Computer 
                      blockchain and therefore subject to its decentralized architecture.
                      </Typography>
                    <Typography component="p" variant="body2" align="left" color="#000000" sx={{pb:1}}>
                      ICArchive reserves the right, at its sole discretion, to make alterations to this 
                      and other policies.  Such changes will accompanied by a change in the date displayed as a part of this document, being in effect as of the date shown.
                    </Typography>
                    <Typography component="p" variant="body2" align="left" color="#000000" sx={{pb:1}}>

                      All open-source ICArchive products are released under the terms of the MIT license and made available to you on an "as is" basis. 
                      Any ICArchive software that you may download from public repositories, or may receive 
                      from social media channels including but not limited to Twitter and Discord, is for your use at your own discretion. ICArchive, its team and its affiliates
                      bear no responsibility and no liabilities whatsoever, for any business outcomes for better or worse. 

                    </Typography>
                    
                <Typography component="p" variant="body2" align="left" color="#000000" sx={{pb:1}}>

                  <i>Last updated: February 2022</i>
                </Typography>



              </Grid>
            </Grid>
          </Paper>

      </Grid>
      </Grid>

    </Paper>


  );
} // end TermsTop

export default TermsTop;